import React, { forwardRef } from 'react'

import { IconProps } from './types'

const Team = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 13H14.5C14.5 10.5 12.5 8.5 10 8.5M1.5 13C1.5 10.5 3.5 8.5 6 8.5C8.5 8.5 10.5 10.5 10.5 13H1.5ZM8 4.5C8 5.60457 7.10457 6.5 6 6.5C4.89543 6.5 4 5.60457 4 4.5C4 3.39543 4.89543 2.5 6 2.5C7.10457 2.5 8 3.39543 8 4.5Z"
        stroke={color}
      />
      <path
        d="M9 6.5H9.5C10.6046 6.5 11.5 5.60457 11.5 4.5C11.5 3.39543 10.6046 2.5 9.5 2.5H9"
        stroke={color}
      />
    </svg>
  ),
)

Team.displayName = 'Team'

Team.defaultProps = {
  size: 16,
  color: 'currentColor',
}

export default Team
